import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import { css } from '@emotion/core';

const Authenticated: React.SFC = () => {
  return (
    <ul
      className="ibm-cloud-sitenav-menu-list ibm-cloud-sitenav-user"
      role="menubar"
      data-testid="authenticated">
      <li className="ibm-cloud-sitenav-haschildlist ibm-cloud-sitenav-level-0">
        <button role="menuitem" aria-expanded="false">
          <FormattedMessage {...messages.account} />
        </button>
        <ul
          role="menu"
          className="ibm-cloud-sitenav-dropdown"
          aria-label="Account menu"
          data-testid="account-menu">
          <li className="ibm-cloud-sitenav-level-1 console">
            <a role="menuitem" href="https://cloud.ibm.com/">
              <FormattedMessage {...messages.console} />
            </a>
          </li>
          <li className="ibm-cloud-sitenav-level-1">
            <a role="menuitem" href="https://cloud.ibm.com/user/">
              <FormattedMessage {...messages.profile} />
            </a>
          </li>
          <li className="ibm-cloud-sitenav-level-1">
            <a role="menuitem" href="https://cloud.ibm.com/catalog/">
              <FormattedMessage {...messages.catalog} />
            </a>
          </li>
          <li className="ibm-cloud-sitenav-level-1">
            <a role="menuitem" href="https://cloud.ibm.com/billing">
              <FormattedMessage {...messages.billingUsage} />
            </a>
          </li>
          <li className="ibm-cloud-sitenav-level-1">
            <a role="menuitem" href="https://cloud.ibm.com/logout">
              <FormattedMessage {...messages.logOut} />
            </a>
          </li>
        </ul>
      </li>
      <li className="ibm-cloud-sitenav-level-0 console">
        <a
          css={styles.consoleLink}
          className="ibm-btn-sec ibm-cloud-sitenav-user__cta-link"
          role="menuitem"
          href="https://cloud.ibm.com/">
          <FormattedMessage {...messages.console} />
        </a>
      </li>
    </ul>
  );
};

const styles = {
  consoleLink: css`
    color: #0062ff;

    &:visited {
      color: #0062ff;
    }

    &:hover {
      color: #fff;
    }
  `,
};

export default Authenticated;
